import { Button } from "@/components/ui/button";
import { ClipboardCheck, Lock } from "lucide-react";

export default function TaskExamCard({ t, isGuide, lockMsg, navigate, testid }) {
  const out = !isGuide && t.attempts_used >= t.max_attempts && !t.in_progress;
  const isMid = t.kind === "midtask";
  const label = isMid ? "Mid-Unit Task Test" : "Unit Task";
  const blockSpan = t.blocks?.length > 1 ? `Blocks ${t.blocks[0]}–${t.blocks[t.blocks.length - 1]}` : "the unit";
  return (
    <section data-testid={`${testid}-card`} className={`hq-glass rounded-2xl p-5 border ${t.passed ? "border-[#34D399]/50" : "border-[#a5b4fc]/40"}`}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <div className="w-12 h-12 rounded-xl bg-[#a5b4fc]/15 text-[#a5b4fc] flex items-center justify-center shrink-0"><ClipboardCheck className="w-6 h-6" /></div>
          <div className="min-w-0">
            <p className="text-[10px] uppercase tracking-widest text-[#a5b4fc]">{isMid ? "Mid-unit" : "End of unit"} · hands-on task{isGuide ? " · Guide preview" : ""}</p>
            <h3 className="font-display text-xl">{t.title}</h3>
            <p className="text-xs text-muted-foreground">{t.screen_count} screens · {t.task_count} tasks from {blockSpan} · {t.minutes} min timer · pass {t.pass}% · +{t.points} pts · {t.max_attempts > 1 ? <span className="text-[#34D399]">reassigned · {t.attempts_used}/{t.max_attempts} used</span> : <span className="text-[#FB923C]">1 attempt (ask your Guide to reassign)</span>}{t.best_score != null ? ` · Best: ${t.best_score}%` : ""}</p>
            {t.best_blocks && <p className="text-[11px] text-slate-400 mt-0.5" data-testid={`${testid}-blocks`}>{Object.entries(t.best_blocks).map(([b, v]) => `B${b} ${v ?? "—"}%`).join(" · ")}</p>}
          </div>
        </div>
        {!t.unlocked ? (
          <span className={`flex items-center gap-2 text-xs shrink-0 ${t.locked_reason === lockMsg ? "text-[#FB923C]" : "text-slate-400"}`} data-testid={`${testid}-locked`}><Lock className="w-4 h-4" /> {t.locked_reason}</span>
        ) : out ? (
          <Button data-testid={`${testid}-done`} disabled variant="outline" className="opacity-60 shrink-0">{t.passed ? "Passed" : "Completed"} ({t.best_score}%)</Button>
        ) : (
          <Button data-testid={`${testid}-start`} onClick={() => navigate(`/unit-task/${t.id}`)} className="bg-[#a5b4fc] text-[#04121f] hover:bg-[#c7d2fe] shrink-0">{t.in_progress ? `Resume ${label}` : t.attempts_used > 0 ? `Retake ${label}` : `Start ${label}`}</Button>
        )}
      </div>
    </section>
  );

}
